<div class="position-relative">
  <div class="item-image">
    <!--Sponsor-->
    <ng-container *ngIf="hasSponsor">
      <div class="corner-icon-container-sponsor">
        <a target="_blank" href="{{ marketplaceItem?.Sponsor?.SponsorLink }}">
          <img src="{{ marketplaceItem?.Sponsor?.SponsorImage | contentImage: '6' : 'marketplace' }}" />
        </a>
      </div>
    </ng-container>
    <!--Item Image-->
    <a
      class="{{ marketplaceItem?.theme }}"
      [owlRouterLink]="'/rewards/marketplace/details/' + marketplaceItem.Id"
      [stopLink]="ignoreLink"
    >
      <div class="card loyalty border-0">
        <div>
          <img
            class="card-img-top"
            [src]="marketplaceItem.ItemImageURL | contentImage: '7' : 'marketplace'"
            alt=""
            [useDefault]="true"
            [loyaltyType]="'marketplace'"
            draggable="false"
          />
        </div>
      </div>
    </a>
  </div>
  <ng-container *ngIf="statusText || marketplaceItem.Locked; else stockAvailableStates">
    @if (marketplaceItem.Locked) {
      <div class="rewards-item-panel-status text-info">
        <span class="icon material-icons me-1 rewards-locked-icon">lock</span>
        {{ 'reward.status.locked' | translate }}
      </div>
    } @else if (statusText) {
      <div class="rewards-item-panel-status {{ 'status-text-on-' + theme }}">{{ statusText | translate }}</div>
    }
  </ng-container>
  <!--Item State-->
  <ng-template #stockAvailableStates>
    <ng-container *ngIf="stockAvailableState">
      <div class="rewards-item-panel-status  {{ textColor }}">
        <ng-container *ngIf="stockAvailableState == MARKETPLACE.FEATURED">
          <span class="icon material-icons text-success font-size-20 me-1">{{ featuredIcon }}</span>
        </ng-container>
        <ng-container *ngIf="stockAvailableState == MARKETPLACE.REMAINING">
          <span class="item-count me-1">{{ marketplaceItem.AvailabilityCount }}</span>
        </ng-container>

        <span class="item-state">{{ stockAvailableState | translate }}</span>
      </div>
    </ng-container>
  </ng-template>
  <!--Item Name-->
  <div class="rewards-item-panel-name">{{ marketplaceItem.DisplayName }}</div>
  <!--Points Value-->
  <ng-container *ngIf="!marketplaceItem.EcashValue && !marketplaceItem.MerchantValue">
    <label class="accessibility-only">Points Value: </label>
    <div *ngIf="marketplaceItem.PointValue > 0" class="rewards-item-panel-value">
      {{ marketplaceItem.PointValue | FortressCurrencyPipe: 'PTS' }}
    </div>
    <!--Display Text if Value is 0 and Available-->
    <div *ngIf="marketplaceItem.PointValue == 0 && marketplaceItem.Status === status.Available" class="rewards-item-panel-value">
      {{ 'fgbcl.marketplace.item.claim.now' | translate }}
    </div>
  </ng-container>
  <!--eCash Value-->
  <ng-container *ngIf="marketplaceItem.EcashValue">
    <label class="accessibility-only">Ecash Value: </label>
    <div class="rewards-item-panel-value" id="ecash-value">{{ marketplaceItem.EcashValue / 100 | FortressCurrencyPipe }}</div>
  </ng-container>
  <!--Merchant Value-->
  <ng-container *ngIf="marketplaceItem.MerchantValue">
    <label class="accessibility-only">Merchant Value: </label>
    <div class="rewards-item-panel-value" id="ecash-value">
      {{ marketplaceItem.MerchantValue / 100 | FortressCurrencyPipe }}
    </div>
  </ng-container>
</div>
